import { useLayoutEffect, useRef, useState, useCallback } from 'react';

export const useMeasureAccordionContentHeight = () => {
  const [contentHeight, setContentHeight] = useState(0);
  const contentRef = useRef(null);
  const resizeObserverRef = useRef(null);

  const measureHeight = useCallback(() => {
    if (contentRef.current) {
      const height = contentRef.current.scrollHeight;
      setContentHeight(height);
    }
  }, []);

  useLayoutEffect(() => {
    const element = contentRef.current;
    if (!element) return;

    measureHeight();

    resizeObserverRef.current = new ResizeObserver(() => {
      measureHeight();
    });

    resizeObserverRef.current.observe(element);

    return () => {
      if (resizeObserverRef.current) {
        resizeObserverRef.current.disconnect();
      }
    };
  }, [measureHeight]);

  return {
    contentRef,
    contentHeight,
    remeasure: measureHeight,
  };
};
